export const OPTIMIZATION_STATUS = {
  QUEUED: 'QUEUED',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
};

// Placeholder for plan-tier based limits
export const DEFAULT_MAX_TIME_SCOPE_DAYS = 31; // up to one month

